import React from 'react'
import { useState, useEffect, useRef } from 'react'
// import './App.css';
import styles from './Main.module.scss'
import AudioPlayer from './AudioPlayer/AudioPlayer'
import Maps from './Maps/Maps'
import Controls from './Controls/Controls'
import PopUp from './PopUp/PopUp'
import GameEnd from './GameEnd/GameEnd'
import { useDispatch } from 'react-redux'
import { addRound } from '../../store/appSlice'

import { Location, LanguageEntry, GameResults } from '../../../types/types'
import { useGenerateLanguage } from '../hooks/useGenerateLanguage'
import { useCountryMatch } from '../hooks/checkGuess'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
// import startNextRound from '../utils/startNextRound'

interface RoundResults {
  winner: LanguageEntry
  gameResults: GameResults
  yourGuess: Location
}

function Main() {
  const dispatch = useDispatch()
  const { checkCountryMatch } = useCountryMatch()
  const { generateLanguage } = useGenerateLanguage()
  const [currentGuess, setCurrentGuess] = useState<Location | null>(null)
  const [currentLanguage, setCurrentLanguage] = useState<LanguageEntry | null>(
    null
  )
  const [popUpShown, setPopUpShown] = useState<boolean>(false)
  const [roundResults, setRoundResults] = useState<RoundResults | null>(null)
  const [gameEnd, setGameEnd] = useState<boolean>(false)
  // const [gameResults, setGameResults] = useState<GameResults | null>(null)
  const hasMounted = useRef(false)
  const currentRound = useSelector((state: RootState) => state.totalRounds)

  useEffect(() => {
    if (!hasMounted.current) {
      generateLanguage().then((language) => {
        dispatch(addRound())
        setCurrentLanguage(language)
      })
      hasMounted.current = true
    }
  }, [])

  const onNextRound = () => {
    setGameEnd(false)

    //add one round to Redux
    dispatch(addRound())
    //reset states
    setCurrentGuess(null)
    setPopUpShown(false)
    // setGameResults(null)
    setRoundResults(null)

    if (currentRound === 5) {
      setGameEnd(true)
    }
  }

  const setPin = ({ newGuess }: { newGuess: Location }) => {
    setCurrentGuess(newGuess)
  }

  const handleGuess = () => {
    if (currentLanguage && currentGuess) {
      const answer = {
        lat: currentLanguage.lat,
        long: currentLanguage.long,
        code: currentLanguage.code,
        level: currentLanguage.level,
      }

      checkCountryMatch(currentGuess, answer).then((result) => {
        //pass the result to the popup
        setRoundResults({
          winner: currentLanguage,
          gameResults: result,
          yourGuess: currentGuess,
        })
        // setGameResults(result)
        setPopUpShown(true)
      })

      //ideally you'd want to load the next round here
      generateLanguage().then((language) => {
        setCurrentLanguage(language)
      })
    } else {
      console.log('No language or guess')
    }
  }

  return (
    <div className={styles.main}>
      {gameEnd && <GameEnd startNewGame={onNextRound} />}
      {popUpShown && roundResults && (
        <PopUp
          nextRound={onNextRound}
          winner={roundResults.winner}
          gameResults={roundResults.gameResults}
          yourGuess={roundResults.yourGuess}
        />
      )}

      <div className={styles.maps}>
        <Maps setPin={setPin} currentGuess={currentGuess} />
      </div>

      {currentLanguage && (
        <div
          className={`${styles.guess} ${
            !popUpShown && !gameEnd && styles.Shown
          }`}
        >
          <div className={styles.play}>
            {currentLanguage && (
              <AudioPlayer
                audioPath={currentLanguage.audioPath}
                currentLanguage={currentLanguage.language}
                onNextRound={onNextRound}
              />
            )}
          </div>
          <div className={styles.controls}>
            <Controls
              currentGuess={currentGuess?.country}
              onGuess={handleGuess}
            />
          </div>
        </div>
      )}

      {!currentLanguage && <p className={styles.loading}>Loading...</p>}
    </div>
  )
}

export default Main
